export enum PRODUCTION_STATES {
  CREATED = 'CREATED',
  IN_QUALITY = 'IN_QUALITY',
  COMPLETED = 'COMPLETED',
  OVERLOADED = 'OVERLOADED',
}
